import { Texts, Title, Media, Button } from "../Object";
import { Space } from "../Layout";

const Flow = () => {
  return(
    <>
      <div className="l-row">
        <Texts slug="title/flow" class="c-text--main c-text--en c-text--big"></Texts>
        <Space size={['64px 0', '48px 0']}>
          <Texts slug="flow/title" class=""></Texts>
        </Space>

        <Space size={['0 auto', '0 auto']}>
          <Media src="flow/media" sp="sp" alt="flow" class="p-img__flow"></Media>
        </Space>
      </div>
    </>
  )
}

export default Flow;